import { NbJSThemeOptions } from '@nebular/theme';

export const LOCKVUE_THEME = {
  name: 'lockvue',
  base: 'default',
  variables: {},
} as NbJSThemeOptions;
